import type { CSSProperties, ReactNode } from 'react';

export type KindType = 'Component' | 'API' | '';

export interface LinkInput {
  url: string;
  title: string;
  icon?: string;
}

export interface FormState {
  name: string;
  namespace: string;
  owner: string;
  description: string;
  system: string;
  domain: string;
  lifecycle: string;
  tags: string;
  // Component-specific
  type: string;
  providesApis: string[];
  consumesApis: string[];
  subcomponentOf: string;
  // API-specific
  apiType: string;
  apiVersion: string;
  links: LinkInput[];
}

export interface ComponentPayload {
  entityKind: 'Component';
  name: string;
  namespace: string;
  owner: string;
  description: string;
  type: string;
  lifecycle: string;
  system: string;
  domain: string;
  tags: string[];
  links: LinkInput[];
  consumesApis: string[];
  providesApis: string[];
  subcomponentOf?: string;
}

export interface ApiPayload {
  entityKind: 'API';
  name: string;
  namespace: string;
  owner: string;
  description: string;
  lifecycle: string;
  system: string;
  domain: string;
  type: string;
  tags: string[];
  links: LinkInput[];
  apiVersion: string;
}

export type SubmitPayload = ComponentPayload | ApiPayload;

export interface DropdownOption {
  label: string;
  value: string;
}

export type SortDirection = 'ASC' | 'DESC';

export interface SortColumn {
  columnKey: string;
  direction: SortDirection;
}

export interface ProposalRow {
  id?: string;
  name?: string;
  kind?: string;
  status?: string;
  system?: string;
  domain?: string;
  owner?: string;
  type?: string;
  lifecycle?: string;
  description?: string;
  payload?: Record<string, any>;
  rejectionReason?: string;
  remark?: string;
}

export interface CatalogRow {
  name: string;
  kind: string;
  type: string;
  owner: string;
  lifecycle: string;
  description: string;
  system: string;
  domain: string;
  tags: string;
}

export type MetaRow = [string, ReactNode, string, ReactNode];

export interface StatusPalette {
  bg: string;
  color: string;
  border: string;
}

export const STATUS_PALETTE: Record<string, StatusPalette> = {
  pending: { bg: '#eef2ff', color: '#3730a3', border: '#c7d2fe' },
  approved: { bg: '#ecfdf3', color: '#047857', border: '#bbf7d0' },
  rejected: { bg: '#fef2f2', color: '#b91c1c', border: '#fecaca' },
};

export enum ActiveTab {
  Catalog = 'Catalog',
  Proposals = 'Proposals',
}

export const LABEL_STYLE: CSSProperties = {
  fontSize: 13,
  fontWeight: 700,
  color: '#1a1a1a',
  marginBottom: 5,
};

export const VALUE_STYLE: CSSProperties = {
  fontSize: 16,
  fontWeight: 400,
  color: '#1a1a1a',
};
